module.exports = ".inputPlaceholder {\n  padding: 6px 12px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modal-edit/create-user/create-user.component.scss
// module id = ./src/app/modal-edit/create-user/create-user.component.scss
// module chunks = main